import { useTheme } from '@web-chat-core/ui-kit';
import { useState } from 'react';
import { ImageProcessorButton, LoadingIcon, LoadingWrapper, PreviewImage } from './view';

interface Props {
    onClick: () => void;
    imageSrc: string;
    disabled?: boolean;
    isSelected?: boolean;
}

export const VirtualBackgroundProcessorImageButton = ({ onClick, imageSrc, disabled, isSelected }: Props) => {
    const theme = useTheme();
    const [isLoaded, setIsLoaded] = useState(false);

    return (
        <ImageProcessorButton onClick={onClick} disabled={disabled} $isSelected={isSelected}>
            <PreviewImage src={imageSrc} alt="preview-image" $isLoaded={isLoaded} onLoad={() => setIsLoaded(true)} />
            {!isLoaded && (
                <LoadingWrapper>
                    <LoadingIcon icon="icSpinner" size={20} color={theme.root.colors.basicColors['90%']} />
                </LoadingWrapper>
            )}
        </ImageProcessorButton>
    );
};
